<template>
  <v-dialog v-model="showModal" :max-width="'35%'" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="'primary-main lighten-'" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white text-center">
          Refer a friend to WriteWise, and if they buy, you get a commission.
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="flex pa-4 black--text">
        <div class="py-2 px-4 text-sm">
          <p class="text-center text-base mb-2"><b>How does it work?</b></p>
          <ol class="list-decimal grid gap-0 pl-4 pb-4">
            <li>Send an email to <a class="text-blue" href="mailto:finance@writewise.io">finance@writewise.io</a> with the name and email of the person you referred.</li>
            <li>If they buy WriteWise, you get 50% of the sale price!*</li>
          </ol>
          <span class="text-xs">*Payments made through PayPal, Stripe, Payoneer, or bank transfer (Chile only).</span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="flat"
          class="!py-3 !bg-primary-danger !text-white mr-4 mb-1 !rounded-xl !tracking-normal !capitalize !h-auto min-w-[120px]"
          @click.stop="cancel">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

export default class Referral extends Vue {
  mounted() { }

  @Prop()
  public isReferral: boolean = false;

  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  get showModal() {
    return this.isReferral;
  }

  set showModal(newValue) {
    this.$emit('update:modelValue', newValue);
  }

  public selectedIndex: number = 0;

  public cancel() {
    this.showModal = false;
  }
}
</script>
